<template>
  <div class="content-image is-type-content-image has-pink-background">
    <div class="content-image__media has--background">
      <div class="content-image__image">
        <img
            :src="commonSettings.image"
            class="attachment-full size-full">
      </div>
    </div>
    <div class="wine-club-step-type content-image__content">
      <!--      <div-->
      <!--        v-for="prepackProduct in prepackProductOptions"-->
      <!--        :key="prepackProduct.product_id"-->
      <!--        class="wine-club-card"-->
      <!--        :class="{ 'wine-club-card&#45;&#45;active': selectedProduct && selectedProduct.product_id === prepackProduct.product_id }"-->
      <!--      >-->
      <!--        <div-->
      <!--          class="wine-club-card__content wine-club-card__content&#45;&#45;with-cta"-->
      <!--        >-->
      <!--          <h3 class="wine-club-card__title">-->
      <!--            {{ prepackProduct.title }}-->
      <!--          </h3>-->
      <!--          <div class="wine-club-card__description">-->
      <!--            {{ prepackProduct.description }}-->
      <!--          </div>-->
      <!--          <div>-->
      <!--            <button class="wine-club-card__cta" @click="selectType(TYPE_PREPACK, prepackProduct)">-->
      <!--              {{ selectedProduct && selectedProduct.product_id === prepackProduct.product_id ? 'Selected' : 'Select' }}-->
      <!--            </button>-->
      <!--            <button class="wine-club-card__footer-link" @click="activatePrepackDetailsPopup(prepackProduct)">-->
      <!--              Preview Selection-->
      <!--            </button>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div
          class="wine-club-card"
          :class="{ 'wine-club-card--active': isSelectedMixed }"
          key="personal"
      >
        <div
            class="wine-club-card__content"
            :style="{'border-color': commonSettings.mixedColor}"
        >
          <h3 class="wine-club-card__title">
            {{ commonSettings.mixedTitle }}
          </h3>
          <div class="wine-club-card__description">
            {{ commonSettings.mixedDescription }}
          </div>
          <button class="wine-club-card__cta" @click="selectType(TYPE_MIXED)">
            {{ isSelectedMixed ? 'Selected' : 'Join now' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {TYPE_MIXED, TYPE_PREPACK} from '../store';

export default {
  data() {
    return {
      TYPE_PREPACK,
      TYPE_MIXED,
    };
  },
  computed: {
    prepackProductOptions() {
      return this.$store.state.prepackProductOptions;
    },
    commonSettings() {
      return this.$store.state.commonSettings;
    },
    selectedType() {
      return this.$store.state.selectedType;
    },
    selectedProduct() {
      return this.$store.state.selectedProduct;
    },
    isSelectedMixed() {
      return this.selectedType === TYPE_MIXED;
    },
  },
  methods: {
    selectType(type, product) {
      this.$store.dispatch('selectType', {type, product});
    },
    activatePrepackDetailsPopup(product) {
      this.$store.dispatch('activatePrepackDetailsPopup', product);
    },
  },
};
</script>